import React, { useEffect, useState } from 'react'
import { useLocale } from 'src/lib/hooks/useLocal'
import InputTextField from '../common/form-elements/InputTextField'
import Link from 'next/link'
import { validateEmail as validate } from 'src/lib/utils/helpers'
import { postRequest } from 'src/lib/core/api-client'
import { alertSeverites, apiURI } from 'src/lib/utils/constants'
import Alerts from '../common/feedback-and-dialog/Alerts'
import { useRouter } from 'next/router'
import useReCaptcha from 'src/lib/hooks/useReCaptcha'

const ResetPassword = () => {
  const { t } = useLocale()
  const router = useRouter()
  const { generateReCaptchaToken } = useReCaptcha()

  const [email, setEmail] = useState<string>('')
  const [emailInvalidMessage, setEmailInvalidMessage] = useState('')

  const [openAlert, setOpenAlert] = useState<string>('')
  const [alertMessage, setAlertMessage] = useState<string>('')

  const { token } = router.query

  const inputStyle = { style: { fontSize: '14px' } }

  useEffect(() => {
    if (token && typeof token === 'string') {
      router.push({
        pathname: '/auth/set-password',
        query: { token }
      })
    }
  }, [token])

  const handleAlerts = (severity: string, message?: string) => {
    setOpenAlert(severity)
    message && setAlertMessage(message)
  }

  const handleCloseAlert = (_event: any, reason: string) => {
    if (reason === 'clickaway') {
      return
    }
    handleAlerts('')
  }

  const validateEmail = async () => {
    if (!Boolean(validate(email))) {
      setEmailInvalidMessage(t('invalid_email'))
      return
    }
    try {
      const payload = {
        email: email,
        captcha_token: await generateReCaptchaToken('resetPassword')
      }
      await postRequest('/merchant-user/forgot-password', apiURI.AUTH_ENGINE, payload)
      router.push({
        pathname: '/auth/email-sent',
        query: { email: email }
      })
    } catch (e: any) {
      handleAlerts(alertSeverites.SEVERITY_ERROR, e?.message)
      console.error(e)
    }
  }

  return (
    <>
      <form
        noValidate
        autoComplete='off'
        onSubmit={e => e.preventDefault()}
        className='flex flex-col border w-[26.5rem] bg-[#FFFFFF] rounded-2xl p-4 gap-4'
      >
        <div className=''>
          <InputTextField
            label='Email'
            inputValue={email}
            inputProps={inputStyle}
            textFieldId={t('email')}
            handleChange={e => setEmail(e.target.value)}
            inputType='email'
            inputPlaceholder={t('email_placeholder')}
          />
        </div>
        {Boolean(emailInvalidMessage) && <p className='text-sm text-center text-[#f44336]'>{'Invalid Email'}</p>}
        <div className=''>
          <button
            onClick={validateEmail}
            type='submit'
            className='w-full flex justify-center items-center h-8 text-sm font-semibold rounded-lg disabled:bg-[#E0E0E0] bg-primary-dark disabled:cursor-not-allowed	disabled:text-[#949494] text-[#ffffff]'
          >
            {t('reset_password')}
          </button>
        </div>
        <div className='text-sm text-center'>
          <p className='text-carbon'>
            {t('dont_have_an_account')}&nbsp;
            <span className='font-semibold text-coal-dark'>
              <Link href='/auth/signup'>{t('sign_up')}</Link>
            </span>
          </p>
        </div>
      </form>
      {openAlert.length ? (
        <Alerts
          open={true}
          duration={2000}
          closeHandler={handleCloseAlert}
          severity={openAlert}
          message={alertMessage}
        />
      ) : null}
    </>
  )
}

export default ResetPassword
